module.exports = __webpack_public_path__ + "img/move1.84340ee4.png";